/**
 * 화면 표시용 포맷 유틸.
 * 여러 컴포넌트에 복제돼 있던 날짜/숫자 포맷 로직을 통합.
 */

// "YYYY-MM-DD" (날짜만). 빈 값이면 fallback.
export function formatDate(d?: any, fallback = "-"): string {
  return d ? String(d).slice(0, 10) : fallback;
}

// "YYYY-MM-DD HH:MM" (분까지). 빈 값이면 fallback.
export function formatDateTime(d?: any, fallback = "-"): string {
  return d ? String(d).replace("T", " ").slice(0, 16) : fallback;
}

// 천단위 콤마. null/undefined/"" 는 0 으로 처리.
export function formatNumber(v?: any): string {
  return Number(v ?? 0).toLocaleString();
}
